import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
// import styled from 'styled-components';

import { Alert, Container, cssVar, getPageValidationInfo, Splash, useSizes } from 'metrix-common3';

import ProfileSummaryMenu from '../CommonComponents/Menu';
import ProfileSummaryQuotes from '../CommonComponents/Quotes';
import ProfileSummaryRecap from '../CommonComponents/Recap';
import ProfileSummaryRisks from '../CommonComponents/Risks';
import ProfileSummaryAction from './Action';
import ProfileSummaryHeader from './Header';

/*const AbsoluteContainer = styled.div`
    width: 100%;
    position: ${props => props.mobile ? 'relative' : 'absolute'};
    bottom: 0;
    right: 50%;
    transform: translate(50%, 0);
`;

const RelativeContainer = styled.div`
    width: 100%;
    position: relative;
`;*/

const ProfileSummary = (props) => {
    const sizes = useSizes();
    const [_documentAccepted, _setDocumentAccepted] = useState(false);
    const [_displaySignaturePad, _setDisplaySignaturePad] = useState(false);
    const [_paymentEmail, _setPaymentEmail] = useState(null);

    const getOperationMessages = () => {
        if (
            !props.context.operation ||
            (props.context.operation &&
                !props.context.operation.errors &&
                !props.context.operation.warnings &&
                !props.context.operation.confirmations)
        ) {
            return null;
        }

        const hasErrors = props.context.operation.errors && props.context.operation.errors.length > 0;
        const hasWarnings = props.context.operation.warnings && props.context.operation.warnings.length > 0;
        const hasConfirmations =
            props.context.operation.confirmations && props.context.operation.confirmations.length > 0;

        const mode = hasErrors ? 'danger' : hasWarnings ? 'info' : '';
        const header = hasErrors ? (
            <FormattedMessage id={'Profile_Summary.error'} />
        ) : hasWarnings ? (
            <FormattedMessage id={'Profile_Summary.warning'} />
        ) : null;

        const messages = [];

        if (hasErrors) {
            props.context.operation.errors.forEach((item) => {
                messages.push({
                    code: item.code,
                    value: item.value ? item.value : item.code,
                    isError: true,
                });
            });
        }

        if (hasWarnings) {
            props.context.operation.warnings.forEach((item) => {
                messages.push({
                    code: item.code,
                    value: item.value ? item.value : item.code,
                    isError: false,
                });
            });
        }

        if (hasConfirmations) {
            props.context.operation.confirmations.forEach((item) => {
                messages.push({
                    code: item.code,
                    value: item.value ? item.value : item.code,
                    isError: false,
                });
            });
        }

        return <Alert mode={mode} header={header} items={messages} />;
    };

    const isCoverageDetailsHidden =
        props.productSettings?.coverageDetailsHiddenInSummary ||
        props.policySummary?.status === 'referred' ||
        props.policySummary?.status === 'accepted';
    const { error, warning } = getPageValidationInfo(props.pageCode, props.validationInfo);
    // const mobile = isMobile(getScreenSize());

    return (
        props.policySummary && (
            <Splash color={cssVar.colorLightMode}>
                <ProfileSummaryHeader {...props} />
                <Container right={sizes.xs} top={sizes.md} left={sizes.xs}>
                    {(props.context.session.userType === 'broker' ||
                        props.context.session.userType === 'administrator') && (
                        <Container fullwidth bottom={sizes.md}>
                            {/*<RelativeContainer fullwidth bottom={sizes.md}>*/}
                            {/*    <AbsoluteContainer mobile={mobile}>*/}
                            <ProfileSummaryMenu {...props} />
                            {/*</AbsoluteContainer>*/}
                            {getOperationMessages()}
                            {props.policySummary?.messages && props.policySummary.messages.length > 0 && (
                                <Alert
                                    header={<FormattedMessage id={'Profile_Summary.attention'} />}
                                    items={props.policySummary.messages}
                                />
                            )}
                            {error.message.length !== 0 && (
                                <Alert mode='danger' header={error.title} items={error.message} />
                            )}
                            {warning.message.length !== 0 && (
                                <Alert mode='warning' header={warning.title} items={warning.message} />
                            )}
                            {/*</RelativeContainer>*/}
                        </Container>
                    )}
                    <ProfileSummaryAction {...props} />
                    {(props.policySummary?.status === 'quoteAccepted' ||
                        props.policySummary?.status === 'quoteIssued' ||
                        props.policySummary?.status === 'bindRequested' ||
                        props.policySummary?.status === 'bound' ||
                        props.policySummary?.status === 'issued') &&
                        !isCoverageDetailsHidden && <ProfileSummaryRecap {...props} />}
                    {!isCoverageDetailsHidden && <ProfileSummaryRisks {...props} risks={props.policySummary.risks} />}
                    {(props.policySummary.status === 'quoted' || props.policySummary.status === 'referred') && (
                        <ProfileSummaryQuotes {...props} />
                    )}
                </Container>
            </Splash>
        )
    );
};

export default ProfileSummary;
